import { Sentry } from '@/vendors/Sentry';
import { Capacitor } from '@capacitor/core';
import { LocalNotifications } from '@capacitor/local-notifications';

let notificationIdCounter = 1;

function generateNotificationId() {
  return notificationIdCounter++;
}

export const useLocalNotification = (
  callback,
  { title, body, actionTypeId, ongoing = false }
) => {
  const id = generateNotificationId();

  const sendNotification = async () => {
    try {
      if (Capacitor.isNativePlatform()) {
        const permission = await LocalNotifications.checkPermissions();
        if (permission.display === 'granted') {
          return LocalNotifications.schedule({
            notifications: [
              {
                title,
                body,
                id,
                sound: null,
                attachments: null,    
                // schedule: { at: new Date(Date.now() + 1000) }, // Schedule notification for 1 second from now
                actionTypeId,
                actions: [
                  {
                    id: actionTypeId,
                    title,
                  },
                ],
                ongoing,
              },
            ],
          });
        } else {
          await LocalNotifications.requestPermissions();
        }
      }
    } catch (e) {
      Sentry.captureException(e);
    }
  };

  const addListener = async () => {
    // const { granted } = await LocalNotifications.requestPermissions();

    const { remove } = await LocalNotifications.addListener(
      'localNotificationActionPerformed',
      (notification) => {
        if (notification.notification.actionTypeId === actionTypeId) {
          callback();
        }
      }
    );
    return remove;
  };

  const cancelNotification = () =>
    LocalNotifications.cancel({ notifications: [{ id }] });

  return { sendNotification, addListener, cancelNotification };
};
